import React from "react";

import { Link, LinkProps } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles<{ color: string; fontSize: number }>({
  name: "RouteLink",
})((theme, { color, fontSize }) => ({
  root: {
    color,
    textDecorationColor: color,
    fontSize,
    textDecoration: "none",
    transition: "color 0.2s ease",
    "&:hover": {
      textDecoration: "underline",
      textDecorationColor: color,
    },
  },
}));

interface RouteLinkProps extends Omit<LinkProps, "component"> {
  to: string;
  color?: string;
  fontSize?: number;
  children: React.ReactNode;
}

const RouteLink: React.FC<RouteLinkProps> = ({
  to,
  color = "#464646",
  fontSize = 14,
  className,
  children,
  ...props
}) => {
  const { classes, cx } = useStyles({ color, fontSize });

  return (
    <Link component={RouterLink} to={to} className={cx(classes.root, className)} {...props}>
      {children}
    </Link>
  );
};

export default RouteLink;
